/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 * Styles for the new campaign rateplan card header
 *
 * @author Nikolay Sviridov
 * @version 1.39.0
 * @since 1.39.0
 */

import { EllipsisText } from '@nexign/scc-ui-kit';
import styled from 'styled-components';

import { colors } from '@/main/theme';

type TRatePlanCard2025Title = {
	$backgroundColor?: string;
};

type TRatePlanText = {
	$textColor?: string;
};

type TRatePlanIcon = {
	$iconColor?: string;
};

export const RatePlanIconStyled = styled.div.attrs({
	className: 'Rateplan_icon',
})<TRatePlanIcon>`
	svg {
		fill: ${props => props.$iconColor ?? colors.FreshAsphalt};
	}
`;

export const RatePlanCard2025HeadStyled = styled.div.attrs({
	className: 'Rateplan_card_2025_title',
})<TRatePlanCard2025Title>`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 265px;
	height: 140px;
	gap: 8px;
	opacity: 1;
	border-top-left-radius: 24px;
	border-top-right-radius: 24px;
	padding: 16px 8px 16px 16px;
	background-color: ${props => props.$backgroundColor ?? colors.tariffsCard2025TitleBackground};

	position: relative;
`;

export const RatePlanCard2025Title = styled.div`
	height: 40px;
	gap: 2px;
	opacity: 1;
`;

export const TitleCategory = styled(EllipsisText).attrs({
	className: 'Title_Category',
})<TRatePlanText>`
	& .MuiTypography-root {
		font-weight: 500;
		line-height: 18px;
		white-space: pre-wrap;
		color: ${props => props.$textColor ?? colors.FreshAsphalt};
	}
`;

export const TitleRateplanAndIcon = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 4px;
`;

export const TitleRateplan = styled(EllipsisText).attrs({
	className: 'Title_Rateplan',
})<TRatePlanText>`
	& .MuiTypography-root {
		color: ${props => props.$textColor ?? colors.FreshAsphalt};
		margin-bottom: 0;
		white-space: pre-wrap;
	}
`;
